import { useEffect } from 'react';
import { reactHookForm } from '@yola/ws-ui';
import fieldNames from '../constants/field-names';
import setupSteps from '../constants/setup-steps';
import getFieldIdsByKey from '../helpers/get-field-ids-by-key';
import generateFieldKey from '../helpers/generate-field-key';

const { useForm } = reactHookForm;

const getDefaultValues = (initialValues) => ({
  [fieldNames.SERVICE]: '',
  [fieldNames.NEW_WEBSITE_DESCRIPTION]: '',
  [fieldNames.NEW_WEBSITE_CONTENT]: '',
  [fieldNames.NEW_WEBSITE_CONTENT_TYPES]: [],
  [fieldNames.NEW_WEBSITE_CONTENT_OTHER_TYPE]: '',
  [fieldNames.NEW_WEBSITE_EXPECTED_FEATURES]: '',
  [fieldNames.WEBSITE_DESCRIPTION]: '',
  [fieldNames.WEBSITE_EXPECTED_IMPROVEMENTS]: '',
  [fieldNames.MIGRATION_WEBSITE_URL]: '',
  [fieldNames.MIGRATION_PLATFORM]: '',
  [fieldNames.MIGRATION_PLATFORM_OTHER]: '',
  [fieldNames.MIGRATION_REASON]: [],
  [fieldNames.MIGRATION_REASON_OTHER]: '',
  [fieldNames.MIGRATION_EXPECTED_IMPROVEMENTS]: '',
  [fieldNames.CONTACT_INFO_USER_FULL_NAME]: initialValues.userFullName || '',
  [fieldNames.CONTACT_INFO_USER_EMAIL]: initialValues.userEmail || '',
  [fieldNames.CONTACT_INFO_USER_PHONE]: '',
});

function useSetupForm({ activeStepId, fields, resetSteps, initialValues }) {
  const { control, trigger, watch, getValues, setFocus } = useForm({
    defaultValues: getDefaultValues(initialValues),
    mode: 'all',
  });

  const serviceValue = watch(fieldNames.SERVICE);

  const fieldKey = generateFieldKey(
    activeStepId,
    activeStepId === setupSteps.DETAILS ? serviceValue : ''
  );
  const activeStepFieldIds = getFieldIdsByKey(fieldKey);
  const activeStepFieldNames = activeStepFieldIds.map(
    (id) => fields.find((field) => field.id === id)?.name
  );

  const triggerValidation = () => trigger(activeStepFieldNames, { shouldFocus: true });

  useEffect(() => {
    resetSteps();
    // eslint-disable-next-line yola/react-hooks/exhaustive-deps
  }, [serviceValue]);

  return {
    control,
    getValues,
    triggerValidation,
    setFocus,
    activeStepFieldIds,
    activeStepFieldNames,
  };
}

export default useSetupForm;
